import { Link } from "react-router-dom";
import { Logo } from "./Header";

export default function Footer() {
    return (
        <footer className="relative border-t border-white/5 bg-void" data-testid="site-footer">
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-28 pb-10">
                <div className="grid grid-cols-2 md:grid-cols-12 gap-10 mb-24">
                    <div className="col-span-2 md:col-span-4">
                        <Logo />
                        <p className="mt-6 text-secondary text-sm max-w-xs leading-relaxed">
                            An underground circuit for the top 1%. Register a team, climb the ladder, get paid to compete.
                        </p>
                    </div>
                    <FooterCol title="Play" links={[["Tournaments","/tournaments"],["Teams","/teams"],["Rankings","/leaderboard"],["Roadmap","/roadmap"]]} />
                    <FooterCol title="Company" links={[["Mission","/manifesto"],["Rules","/rules"],["Champions","/champions"],["Sign in","/login"],["Enter arena","/register"]]} />
                    <FooterCol title="Circuit" links={[["Warzone","/tournaments"],["MW4 Multiplayer","/tournaments"],["State Circuits","/roadmap"],["National Tour","/roadmap"]]} />
                </div>

                <div className="overflow-hidden">
                    <div className="font-display font-black tracking-tighter leading-[0.85] text-[18vw] text-outline whitespace-nowrap select-none">
                        RANKED PLAY
                    </div>
                </div>

                <div className="mt-10 pt-10 border-t border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="font-mono text-[11px] tracking-[0.24em] text-white/40 uppercase">
                        © 2025 Ranked Play Tournaments · Est. Underground
                    </div>
                    <div className="font-mono text-[11px] tracking-[0.24em] text-white/40 uppercase">
                        System status: <span className="text-volt">● operational</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const FooterCol = ({ title, links }) => (
    <div className="col-span-1 md:col-span-2 md:col-start-auto">
        <div className="overline mb-5 text-white/40">/ {title}</div>
        <ul className="space-y-3">
            {links.map(([label, href]) => (
                <li key={label}>
                    <Link to={href} className="text-white/70 hover:text-volt text-sm transition-colors">{label}</Link>
                </li>
            ))}
        </ul>
    </div>
);
